'use client'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { GripVerticalIcon, Trash2Icon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = {
  id: string
  value: string
  onChange: (value: string) => void
  onRemove: () => void
  placeholder: string
  error?: string
}

export const SortableFaxItem = ({ id, value, onChange, onRemove, placeholder, error }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  return (
    <div ref={setNodeRef} style={style}>
      <div className="flex items-center gap-2">
        <div {...attributes} {...listeners} className="flex cursor-grab items-center active:cursor-grabbing">
          <GripVerticalIcon className="text-muted-foreground h-5 w-5" />
        </div>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          className="flex-1"
          aria-invalid={!!error}
          data-invalid={!!error || undefined}
        />
        <Button type="button" variant="ghost" size="icon" onClick={onRemove}>
          <Trash2Icon className="h-4 w-4" />
        </Button>
      </div>
      {error && (
        <p className="text-destructive text-sm" role="alert" aria-live="polite">
          {error}
        </p>
      )}
    </div>
  )
}
